function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.6569 5.62329C7.03439 7.02356 5.63123 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.09134 0 7.80782 1.60496 7.98493 3.65037L12.3431 4.37673C12.9656 2.97645 14.3688 2 16 2C18.2091 2 20 3.79086 20 6C20 8.20914 18.2091 10 16 10C14.9749 10 14.04 9.61443 13.3321 8.9804L7.77815 12.6831C7.88518 12.9902 7.95583 13.3143 7.98493 13.6504L12.3431 14.3767C12.9656 12.9764 14.3688 12 16 12C18.2091 12 20 13.7909 20 16C20 18.2091 18.2091 20 16 20C13.9087 20 12.1922 18.3951 12.0151 16.3497L7.6569 15.6233C7.03439 17.0236 5.63123 18 4 18C1.79086 18 0 16.2091 0 14C0 11.7909 1.79086 10 4 10C5.02504 10 5.96002 10.3856 6.66784 11.0196L12.2218 7.3169C12.1148 7.00981 12.0442 6.68568 12.0151 6.34965L7.6569 5.62329Z",
  fill: "#666AF6"
});

function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.11145892.svg";
export { ForwardRef as ReactComponent };